import { DEFAULT_NOTIFICATION_TIMEOUT_MS, MessageType } from '../constants/createSegment';
import { API_ERROR } from '../constants/editorConfig';
import {
  FAILED_CAMPAIGN_CREATION,
  FAILED_CAMPAIGN_DELETE,
  SUCCESS_CAMPAIGN_CREATION,
  SUCCESS_CAMPAIGN_DELETE,
} from '../constants/messages';
import {
  CREATE_SCHEDULE_URL,
  DELETE_CAMPAIGN_URL,
  GET_ALL_CAMPAIGN_METRIC_URL,
  GET_ALL_CAMPAIGN_URL,
  GET_CAMPAIGN_METRICS_URL
} from '../constants/urlConstants';
import { ResponseStatus } from '../enums/responseStatus';
import { CampaignFormSection } from '../enums/schedulingConstant';
import apiRequest from '../util/apiRequest';
import {
  CAMPAIGN_FORM_UPDATE_SEGMENT_DETAIL,
  CAMPAIGN_FORM_UPDATE_TEMPLATE_DETAIL,
  CREATE_SCHEDULE_ACTION,
  CAMPAIGN_FORM_UPDATE_SCHEDULE_DETAIL,
  CAMPAIGN_FORM_ERROR,
  UPDATE_CURRENT_FORM_STEP,
  CLEAR_CAMPAIGN_FORM,
  UPDATE_FORM_SUBMISSION_STATUS,
  TEST_EMAIL_ACTION,
  GET_ALL_CAMPAIGNS
} from './createScheduleActionTypes';
import { SHOW_NOTIFICATON } from './notificationActionsType';
import { apiRequestWithoutInterceptor } from '../util/apiRequest';

export const createCampaign = (payload, sessionToken) => dispatch => {
  let status = ResponseStatus.PENDING;
  let response = {};
  dispatch({
    type: CREATE_SCHEDULE_ACTION,
    payload: {
      status,
      response,
    },
  });
  return apiRequest(
    CREATE_SCHEDULE_URL,
    {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify({ ...payload }),
    },
    sessionToken,
  )
    .then(res => {
      if (!res.ok) {
        status = ResponseStatus.ERROR;
        throw Error(API_ERROR);
      }
      return res.json();
    })
    .then(res => {
      status = ResponseStatus.SUCCESS;
      response = res;
      dispatch({
        type: SHOW_NOTIFICATON,
        payload: {
          type: MessageType.SUCCESS,
          timeout: DEFAULT_NOTIFICATION_TIMEOUT_MS,
          message: SUCCESS_CAMPAIGN_CREATION,
        },
      });
    })
    .catch(ex => {
      status = ResponseStatus.ERROR;
      dispatch({
        type: SHOW_NOTIFICATON,
        payload: {
          type: MessageType.ERROR,
          timeout: DEFAULT_NOTIFICATION_TIMEOUT_MS,
          message: FAILED_CAMPAIGN_CREATION,
        },
      });
    })
    .finally(() => {
      dispatch({
        type: CREATE_SCHEDULE_ACTION,
        payload: {
          status,
          response,
        },
      });
    });
};

export const triggerTestEmail = (payload, sessionToken) => dispatch => {
  let status = ResponseStatus.PENDING;
  let response = {};
  dispatch({
    type: TEST_EMAIL_ACTION,
    payload: {
      status,
      response,
    },
  });
  return apiRequest(
    CREATE_SCHEDULE_URL,
    {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify({ ...payload }),
    },
    sessionToken,
  )
    .then(res => {
      if (!res.ok) {
        status = ResponseStatus.ERROR;
        throw Error(API_ERROR);
      }
      return res.json();
    })
    .then(res => {
      status = ResponseStatus.SUCCESS;
      response = res;
    })
    .catch(ex => {
      status = ResponseStatus.ERROR;
    })
    .finally(() => {
      dispatch({
        type: TEST_EMAIL_ACTION,
        payload: {
          status,
          response,
        },
      });
    });
};

export const updateCampaignForm = (sectionName, payload) => dispatch => {
  switch (sectionName) {
    case CampaignFormSection.SEGMENT: {
      dispatch({ type: CAMPAIGN_FORM_UPDATE_SEGMENT_DETAIL, payload });
      break;
    }
    case CampaignFormSection.TEMPLATE: {
      dispatch({ type: CAMPAIGN_FORM_UPDATE_TEMPLATE_DETAIL, payload });
      break;
    }
    case CampaignFormSection.SCHEDULE: {
      dispatch({ type: CAMPAIGN_FORM_UPDATE_SCHEDULE_DETAIL, payload });
      break;
    }
    case CampaignFormSection.CAMPAIGN: {
      dispatch({ type: CAMPAIGN_FORM_UPDATE_SCHEDULE_DETAIL, payload });
      break;
    }
    default: {
      return;
    }
  }
};

export const updateTestEmailDetails = (sectionName, payload) => dispatch => {
  dispatch({ type: TEST_EMAIL_ACTION, payload });
};

export const broadcastFormError = payload => dispatch => {
  dispatch({ type: CAMPAIGN_FORM_ERROR, payload });
};

export const updateCampaignFormStep = payload => dispatch => {
  dispatch({ type: UPDATE_CURRENT_FORM_STEP, payload });
};

export const clearCampaignForm = () => dispatch => {
  dispatch({ type: CLEAR_CAMPAIGN_FORM, payload: {} });
};

export const updateFormSubmissionStatus = state => dispatch => {
  dispatch({ type: UPDATE_FORM_SUBMISSION_STATUS, state });
};

export const getAllCampaigns = (payload, sessionToken) => dispatch => {
  let status = ResponseStatus.PENDING;
  let response = {};
  dispatch({
    type: GET_ALL_CAMPAIGNS,
    payload: {
      status,
      response,
    },
  });
  return apiRequest(
    GET_ALL_CAMPAIGN_URL,
    {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify({ ...payload }),
    },
    sessionToken,
  )
    .then(res => {
      if (!res.ok) {
        status = ResponseStatus.ERROR;
        throw Error(API_ERROR);
      }
      return res.json();
    })
    .then(res => {
      status = ResponseStatus.SUCCESS;
      response = res;
    })
    .catch(ex => {
      status = ResponseStatus.ERROR;
    })
    .finally(() => {
      dispatch({
        type: GET_ALL_CAMPAIGNS,
        payload: {
          status,
          response,
        },
      });
    });
};

export const deleteCampaign = (payload, sessionToken) => dispatch => {
  let status = ResponseStatus.RUNNING;
  return apiRequest(
    DELETE_CAMPAIGN_URL,
    {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify({
        ...payload,
      }),
    },
    sessionToken,
  )
    .then(res => {
      if (!res.ok) {
        status = ResponseStatus.ERROR;
        throw Error(API_ERROR);
      }
      return res.json();
    })
    .then(res => {
      dispatch({
        type: SHOW_NOTIFICATON,
        payload: {
          type: MessageType.SUCCESS,
          message: SUCCESS_CAMPAIGN_DELETE,
          timeout: DEFAULT_NOTIFICATION_TIMEOUT_MS,
        },
      });
    })
    .catch(() => {
      dispatch({
        type: SHOW_NOTIFICATON,
        payload: {
          type: MessageType.ERROR,
          message: FAILED_CAMPAIGN_DELETE,
          timeout: DEFAULT_NOTIFICATION_TIMEOUT_MS,
        },
      });
    });
};

export const getCampaignMetrics = (payload, sessionToken) => {
  let status = ResponseStatus.PENDING;

  return apiRequestWithoutInterceptor(GET_CAMPAIGN_METRICS_URL, {
    method: 'POST', mode: 'cors', body: JSON.stringify({ ...payload }),
  }, sessionToken)
    .then(res => {
      if (!res.ok) {
        status = ResponseStatus.ERROR;
        throw Error(API_ERROR);
      }
      return res.json();
    })
    .then(res => {
      status = ResponseStatus.SUCCESS;
      return {
        status,
        response: res,
      };
    })
    .catch(ex => {
      status = ResponseStatus.ERROR;
      return {
        status,
        response: null,
      };
    });
};

export const getAllCampaignMetrics = (payload, sessionToken) => dispatch => {
  let status = ResponseStatus.PENDING;
  let response = {};
  return apiRequest(
    GET_ALL_CAMPAIGN_METRIC_URL,
    {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify({ ...payload }),
    },
    sessionToken,
  )
    .then(res => {
      if (!res.ok) {
        status = ResponseStatus.ERROR;
        throw Error(API_ERROR);
      }
      return res.json();
    })
    .then(res => {
      status = ResponseStatus.SUCCESS;
      response = res;
    })
    .catch(ex => {
      status = ResponseStatus.ERROR;
    })
    .finally(() => {
      dispatch({
        type: GET_ALL_CAMPAIGNS,
        payload: {
          status,
          response,
        },
      });
    });
};
